import React, { useEffect, useState } from 'react'
import HighMotosPage from 'src/pages/ReportsPages/ReportsBoard/CommercialsReportsPages/HighMotosPage'
import boardReportsService from 'src/services/boardReportsService'

const HighMotosContainer = () => {
  const [total, setTotals] = useState([])
  const [gTotal, setGTotals] = useState([])

  const [selectedDate, setSelectedDate] = useState(new Date())

  const reloadTotals = async () => {
    const response = await boardReportsService.getTotalMarkes('10', selectedDate.getFullYear())
    setTotals(response)
  }

  const reloadGTotal = async () => {
    const response = await boardReportsService.getTotalMarketsGraphics('10', selectedDate.getFullYear())
    setGTotals(response)
  }
  const handleDateChange = value => {
    setSelectedDate(value)
  }

  useEffect(() => {
    reloadTotals()
    reloadGTotal()
  }, [selectedDate])

  return <HighMotosPage total={total} gTotal={gTotal} selectedDate={selectedDate} handleDateChange={handleDateChange} />
}

export default HighMotosContainer
